<template>
  <div class="xiangmu-list">
    <div
      v-for="(item, index) in xiangmuList"
      :key="index"
      class="xiangmu"
      @click="toJingjia2(item)"
    >
      <el-carousel height="220px" indicator-position="none">
        <el-carousel-item v-for="item1 in item.imgList" :key="item1">
          <el-image
            :src="item1"
            alt=""
            style="height: 220px; width: 100%"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
      <!-- <el-image v-if="item.addressimg" :src="requestUrl + item.addressimg" alt=""
                style="height:220px;width:100%"></el-image> -->
      <!-- <div v-else class="imgnull">暂无图片</div> -->
      <!-- <div class="xiang-status">
        {{ item.status == 1 ? "正在招商" : "招商结束" }}
      </div> -->

      <div class="main-content">
        <!-- <div class="xiang-title">{{ item.projectname }}</div> -->
        <div class="xiang-title" v-if="cityDetail.notshowZCZSCity">
          {{ item.title }}
        </div>
        <div class="xiang-title" v-else>{{ item.address + item.title }}</div>

        <!-- <div class="xiang-content">地区：<span> {{item.dm_arr.pid_area_name+item.dm_arr.area_name }}</span></div> -->
        <div class="xiang-content" v-if="!cityDetail.notshowZCZSPrice">
          <img src="../../assets/img/卡片图标1.png" />挂牌价格：<span
            class="price-year"
          >
            {{ item.estimated }}</span
          >元
        </div>
        <!-- <div class="xiang-content">
          <img src="../../assets/img/卡片图标2.png" />招商类型：<span
            v-for="dict in dicts"
            :key="dict.dictCode"
            v-show="item.type == dict.dictValue"
          >
            {{ dict.dictLabel }}</span
          >
        </div> -->
        <div class="xiang-content">
          <img src="../../assets/img/卡片图标3.png" />发布时间：<span>
            {{ item.createTime }}</span
          >
        </div>
        <!-- <div class="xiang-content"><img src="../../assets/img/卡片图标3.png">结束时间：<span> {{ item.jjendtime }}</span>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getDicts } from "../../api/mian.js"
import { cityDetail } from "../../util/mainOption.js"

export default {
  name: "XiangMu",
  data () {
    return {
      number: "001",
      dicts: [],
    }
  },

  mounted () {
    getDicts("invest_type").then((res) => {
      this.dicts = res.data.data
    })
  },
  props: ["xiangmuList"],
  methods: {
    // / 跳转到竞价项目详情页面
    toJingjia2 (i) {
      console.log(i)
      this.$router.push({ name: "资产招商详情", query: { id: i.id } })
    },
  },
};
</script>

<style scoped>
.imgnull {
  height: 220px;
  width: 100%;
  line-height: 220px;
  text-align: center;
  color: #c0c4cc;
  /* font-size: 28px; */
  box-sizing: border-box;
  background-color: #f5f7fa;
  /* border-bottom:1px solid #666 ; */
}

.price-year {
  color: red;
  font-size: 20px;
  font-weight: 500;
}

.xiangmu-list {
  /* position: relative; */
  min-height: 400px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  font-size: 16px;
  padding: 10px;
}

.main-content {
  padding: 10px 20px 10px 20px;
}

.greenClass {
  background-color: #00a213;
}

.redClass {
  background-color: #ff0000;
}

.orangeClass {
  background-color: orange;
}

.xiang-status {
  width: 100px;
  height: 40px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 10px 0 0 10px;
  float: right;
  background-color: #ff0000;
  position: absolute;
  right: 0;

  top: 160px;
  z-index: 99;

  /* position: relative;


    right: 0;
    top: 30px; */
}

.xiang-title {
  /* border: 1px solid red; */
  /* text-align: center;  */
  width: 390px;
  /* width: 100%; */
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 10px;
  color: #262626;
  height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.xiangmu {
  cursor: pointer;
  height: 420px;
  position: relative;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  transition-timing-function: ease-out;
  transition-duration: 300ms;
}

.xiangmu:hover {
  border: 3px solid red;
  transform: translate(0, -5px);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
}

.xiang-content {
  /* border: 1px solid red; */
  font-size: 20px;
  height: 37px;
  line-height: 37px;
  color: #616161;
}

.xiang-content > img {
  width: 20px;
  margin-right: 10px;
}
</style>
